update_cart_totals = ( ) ->
    items = 0
    $( '.quantity-editor' ).each( ( ) ->
        items += parseInt( $( @ ).val( ) )
    )
    cart_total_items = $( '#cart-total-items' )
    cart_total_items.text( items )

    cart_total_sum = $( '#cart-total-sum' )
    cart_total_sum.text( $( '.cart-total' ).text( ) )

cart_setup = ( ) ->
    cart_short_info = $( '#cart-short-info' )
    cart_requisites = $( '.cart-requisites-wrapper' )
    cart_show_btn = $( '#cart-show' )
    cart_hide_bth = $( '#cart-hide' )
    cart_content = $( '#carttable' )

    cart_hide = ( ) ->
        cart_short_info.show( )
        cart_hide_bth.hide( )
        cart_content.hide( )
        cart_requisites.hide( )
        localStorage.setItem( 'IS_CART_HIDE', true )

    cart_show = ( ) ->
        cart_short_info.hide( )
        cart_hide_bth.show( )
        cart_content.show( )
        cart_requisites.show( )
        localStorage.setItem( 'IS_CART_HIDE', false )

    cart_hide_bth.click( cart_hide )
    cart_show_btn.click( cart_show )
    update_cart_totals( )

    if JSON.parse( localStorage.getItem( 'IS_CART_HIDE' ) )
        cart_hide( )
    else
        cart_show( )